import { ElementIds } from 'types';

export const mapFromList = (ids: ElementIds): Record<string, boolean> =>
  ids.reduce((result, id) => {
    result[id] = true;
    return result;
  }, {} as Record<string, boolean>);
